/* eslint-disable react/prop-types */
import React from 'react';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { TextField } from '@mui/material';
import dayjs from 'dayjs';

/**
 * Reusable date picker — always displays as DD/MM/YYYY.
 * value   : ISO string "YYYY-MM-DD" or null
 * onChange : called with "YYYY-MM-DD" string or null
 */
export default function MDDatePicker({ value, onChange, label, disabled, minDate, maxDate, size = 'small', sx = {} }) {
  const dayjsVal = value ? dayjs(value, 'YYYY-MM-DD') : null;

  const handleChange = (newVal) => {
    if (!newVal || !newVal.isValid()) { onChange(null); return; }
    onChange(newVal.format('YYYY-MM-DD'));
  };

  return (
    <DatePicker
      value={dayjsVal}
      onChange={handleChange}
      disabled={disabled}
      minDate={minDate ? dayjs(minDate, 'YYYY-MM-DD') : undefined}
      maxDate={maxDate ? dayjs(maxDate, 'YYYY-MM-DD') : undefined}
      inputFormat="DD/MM/YYYY"
      mask="__/__/____"
      renderInput={(params) => (
        <TextField
          {...params}
          size={size}
          label={label}
          fullWidth
          sx={{ '& .MuiOutlinedInput-root': { height: size === 'small' ? 34 : 44, fontSize: '0.82rem' }, ...sx }}
        />
      )}
    />
  );
}
